import {Component, OnInit, TemplateRef, ViewChild, ChangeDetectionStrategy} from "@angular/core";
import {UntypedFormBuilder, Validators} from "@angular/forms";
import {LogementService} from "../../../services/logement.service";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CookieService} from "ngx-cookie-service";
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from "../../../services/auth.service";
import {environment} from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import {objectToFormData} from "object-to-formdata";
import {Router} from "@angular/router";

@Component({
    selector: 'app-questionnaire-parcours-travaux',
    templateUrl: './questionnaire.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class questionnaireComponent implements OnInit {
  baseApiUrl: string = environment.api.baseUrl;
  inParcoursTravaux = false;
  @ViewChild('confirmationModal') confirmationModalTemplate: TemplateRef<any>;

  projetElement: string[] = [
    "Estimation du coût des travaux recommandés",
    "Impact estimé de la simulation de travaux sur l'étiquette DPE",
    "Conseils personnalisés pour la rénovation de votre logement",
    "Sélectionner moi-même mon programme de travaux",
    "Enregistrer mon scenario de travaux",
  ];

  difficulteTravauxRenovationList: string[] = [
    'Il est difficile de trouver des artisans de confiance',
    'La gestion quotidienne des travaux est complexe',
    'Les travaux sont coûteux',
    'Je ne sais pas par où commencer',
    'Cela prend trop de temps',
    'Cela nécessite trop de connaissances techniques',
    'Je trouve qu’il n’y a aucune difficulté liée aux travaux de rénovation',
  ];

  form = this.fb.group({
    usageLogement: ['', Validators.required],
    typeLogement: ['', Validators.required],
    difficulteTravauxRenovation: this.fb.array(this.difficulteTravauxRenovationList.map(x => !x)),
    projetTravauxPrevision: ['', Validators.required],
    q5: ['', Validators.required],
    q6: ['', Validators.required],
    q7: ['', Validators.required],
    q7_2: ['', Validators.required],
    q8_1: ['', Validators.required],
    q8_2: ['', Validators.required],
    q8_3: ['', Validators.required],
    q8_4: ['', Validators.required],
    q8_5: ['', Validators.required],
    q8_bis: ['', Validators.required],
    q9: ['', Validators.required],
    q9_2: ['', Validators.required],
    q10: ['', Validators.required],
    q10_1: ['', Validators.required],
    q10_2: ['', Validators.required],
    q12: ['', Validators.required],
    q13: ['', Validators.required],
    q14: ['', Validators.required],
    q14_2: ['', [
      Validators.required,
      Validators.pattern(/^0[1-9]\d{8}$/)
    ]
    ],
    q14_3: ['', [
      Validators.required,
      Validators.email
    ]],
  });
  private modal: NgbModalRef;
  private modalOpened = false;
  private modalOpenCall: boolean;
  formValid = false;
  readonly projetIndefinit: string = 'Non je n’ai pas de projet défini';
  readonly projetEncours: string = 'Oui j’ai un projet concret en cours';
  readonly projetFutur: string = 'Oui j’ai un projet prévu dans un futur proche';
  readonly projetRenseignement: string = 'Je me renseigne';
  readonly autre: string = "autre";
  readonly oui: string = "Oui";
  formSubmited = false;
  private authenticated: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private logementService: LogementService,
    public modalService: NgbModal,
    private cookieService: CookieService,
    private authService: AuthService,
    private http: HttpClient,
    private router: Router
  ) {
    router.events.subscribe((val) => {
      this.checkParcoursTravaux();
    });
  }

  ngOnInit(): void {
    this.authService.isAuthenticated().then((authenticated) => {
      this.authenticated = authenticated;
      this.checkParcoursTravaux();
    });
    this.form.valueChanges.subscribe(() => {
      this.formValid = this.checkFormValid();
    });
    this.logementService.logementCourant.subscribe(logement => {
    });
  }

  submit() {
    const difficulteTravauxRenovation = [];
    const formData = this.form.getRawValue();
    this.form.value.difficulteTravauxRenovation.forEach((item, index) => {
      if (item) {
        difficulteTravauxRenovation.push(this.difficulteTravauxRenovationList[index]);
      }
    });

    let url = `${this.baseApiUrl}projet-travaux-poll`;
    if (this.authService.isParcoursTravauDetailxRoute() && !this.authenticated) {
      url = url + `/${localStorage.getItem('projetTravauxIdToStore')}`;
    }

    formData.difficulteTravauxRenovation = difficulteTravauxRenovation;
    this.http.post(url, objectToFormData(formData)).toPromise().then(data => {
    });
    this.disablePoll();
    this.formSubmited = true;
  }

  convertToValue(key: string) {
    return this.form.value[key].map((x, i) => x && this[key][i]).filter(x => !!x);
  }

  close() {
    this.modal.dismiss();
  }

  open() {
    if (this.cookieService.get('questionnaire-parcours-travaux-skip')) {
      return;
    }
    if (!this.authenticated) {
      this.triggerDisplayModal();
    }
    this.http.get(`${this.baseApiUrl}projet-travaux-poll/display-poll`).toPromise().then(data => {
      if (true === data) {
        this.triggerDisplayModal();
      }
      if (false === data) {
        this.disablePoll();
      }
    });
  }

  private triggerDisplayModal() {
    if (!this.modalOpened) {
      if(this.authenticated){
        this.delayModalOpen();
      }else{
        setTimeout(function(this){
          this.delayModalOpen();
        }.bind(this),10000);
      }
    }
    this.modalOpened = true;
  }

  private delayModalOpen(){
    this.modal = this.modalService.open(this.confirmationModalTemplate, {size: 'lg'});
    this.modalService.activeInstances.subscribe((activeModals: NgbActiveModal[]) => {
      if (0 === activeModals.length) {
        this.resetAfterClose();
      }
    });
  }

  private disablePoll() {
    this.cookieService.set('questionnaire-parcours-travaux-skip', "1");
  }

  private checkParcoursTravaux() {
    if (this.authService.isParcoursTravauDetailxRoute() && !this.authenticated) {
      this.openModal();
    }
    if (this.authService.isParcoursTravauxRoute()) {
      this.inParcoursTravaux = true;
    } else {
      if (this.inParcoursTravaux) {
        this.openModal();
      }
    }
  }

  private openModal() {
    if (!this.modalOpenCall) {
      this.open();
    }
    this.modalOpenCall = true;
  }

  private closeModal() {
    this.modal.close();
    this.disablePoll();
  }

  skipPoll() {
    if (!this.authenticated) {
      this.closeModal();
    } else {
      this.http.get(`${this.baseApiUrl}projet-travaux-poll/skip-poll`).toPromise().then(data => {
        this.closeModal();
      });
    }
  }

  isProjetIndefinit(): boolean {
    return this.projetRenseignement !== this.form.value.projetTravauxPrevision &&
      this.projetEncours !== this.form.value.projetTravauxPrevision &&
      this.projetFutur !== this.form.value.projetTravauxPrevision
      ;
  }

  isProjetEnCours(): boolean {
    return this.projetEncours === this.form.value.projetTravauxPrevision;
  }

  isBesoinAutresInformations(): boolean {
    return this.oui === this.form.value.q7;

  }

  isAutre(): boolean {
    return this.autre === this.form.value.q9;
  }

  isAutresOutils() {
    return this.oui === this.form.value.q10;
  }

  isContactezMoi() {
    return this.oui === this.form.value.q14;
  }

  checkFormValid() {
    const formCheckItems = [
      'usageLogement',
      'typeLogement',
      'difficulteTravauxRenovation',
      'projetTravauxPrevision',
    ];
    if (!this.isProjetIndefinit()) {
      formCheckItems.push('q5', 'q6', 'q7', 'q9',
        'q10', 'q12', 'q13', 'q14',
        'q8_1', 'q8_2', 'q8_3', 'q8_4', 'q8_5'
      );
      if (!this.isProjetEnCours()) {
        formCheckItems.push('q8_bis');
      }

      if (this.isAutre()) {
        formCheckItems.push('q9_2');
      }
      if (this.isAutresOutils()) {
        formCheckItems.push('q10_1', 'q10_2');
      }
      if (this.isBesoinAutresInformations()) {
        formCheckItems.push('q7_2');
      }
      if (this.isContactezMoi()) {
        formCheckItems.push('q14_2', 'q14_3');

      }
    }
    for (const item of formCheckItems) {
      if (!this.form.controls[item].valid) {
        return false;
      }
    }

    return true;
  }

  private resetAfterClose() {
    this.modalOpened = false;
    this.modalOpenCall = false;
    this.inParcoursTravaux = false;
  }
}
